import { render, staticRenderFns } from "./BookingPositionPending.vue?vue&type=template&id=06b55555&scoped=true&"
import script from "./BookingPositionPending.vue?vue&type=script&lang=js&"
export * from "./BookingPositionPending.vue?vue&type=script&lang=js&"
import style0 from "./BookingPositionPending.vue?vue&type=style&index=0&id=06b55555&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b55555",
  null
  
)

export default component.exports